import { InjectionToken } from '@angular/core';

import { type AppKit, type PublicStateControllerState, type UseAppKitAccountReturn, type UseAppKitNetworkReturn } from '@reown/appkit';

import { environment, ReownAppKitNetworkConfig } from '@drf/environments';

export type ReownAppKitAccountState = UseAppKitAccountReturn;
export type ReownAppKitNetworkState = Omit<UseAppKitNetworkReturn, 'switchNetwork'>;
export type ReownAppKitPublicState = PublicStateControllerState;

export type ReownAppKitModal = Pick<
  AppKit,
  | 'close'
  | 'disconnect'
  | 'getAddress'
  | 'getCaipNetworks'
  | 'getChainId'
  | 'getIsConnectedState'
  | 'getWalletProvider'
  | 'open'
  | 'setCaipNetwork'
  | 'subscribeAccount'
  | 'subscribeNetwork'
  | 'subscribeState'
  | 'switchNetwork'
> & {
  getAccount(namespace?: 'eip155'): ReownAppKitAccountState | undefined;
};

export interface ReownAppKitAccess {
  getCachedModal(): ReownAppKitModal | null;
  getModal(): Promise<ReownAppKitModal | null>;
  isConfigured(): boolean;
  requireModal(): Promise<ReownAppKitModal>;
}

export interface ReownAppKitConfig {
  analytics: boolean;
  enableReconnect: boolean;
  metadata: {
    description: string;
    icons: string[];
    name: string;
    url: string;
  };
  projectId: string;
}

export const REOWN_APPKIT_CONFIG = new InjectionToken<ReownAppKitConfig>('Reown AppKit config', {
  providedIn: 'root',
  factory: () => environment.reown,
});

export const REOWN_APPKIT_ACCESS = new InjectionToken<ReownAppKitAccess>('Reown AppKit access');

export const REOWN_APPKIT_NETWORKS = new InjectionToken<ReownAppKitNetworkConfig[]>('Reown AppKit networks', {
  providedIn: 'root',
  factory: () => environment.networks,
});

export const REOWN_APPKIT_MODAL = new InjectionToken<ReownAppKitModal | null>('Reown AppKit modal', {
  providedIn: 'root',
  factory: () => null,
});
